import { useEffect, useRef, useMemo } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { isEqual } from 'lodash'
import { useSelector } from 'react-redux'

import driverMapApi from 'apis/disApi/driverMapApi'

const driverMapEmailKey = {
	prefixKey: ['getDrives'],
	drives: (userId, from, to, showHistory) => [
		...driverMapEmailKey.prefixKey,
		userId,
		from,
		to,
		showHistory,
	],
	drive: (driveId, userId) => [...driverMapEmailKey.prefixKey, userId, driveId],
}
export const useDrives = ({
	driveId,
	userId,
	fromDate,
	toDate,
	showHistory,
	allDrivesQueryRef,
}) => {
	const environment = useSelector((state) => state.environment)
	const queryClient = useQueryClient()
	const queryKey = useMemo(() => {
		if (!userId || typeof showHistory === 'string') return null

		if (driveId) return driverMapEmailKey.drive(driveId, userId)
		return driverMapEmailKey.drives(userId, fromDate, toDate, showHistory)
	}, [driveId, userId, fromDate, toDate, showHistory])

	// const [completedDrives, setCompletedDrives] = useState([])
	// const [activeDrives, setActiveDrives] = useState([])
	// const [allDrives, setAllDrives] = useState([])

	useEffect(() => {
		if (!allDrivesQueryRef) return

		if (!queryKey) {
			if (allDrivesQueryRef.current != null) {
				allDrivesQueryRef.current = null
			}
			return
		}

		if (isEqual(allDrivesQueryRef.current, queryKey)) return

		allDrivesQueryRef.current = queryKey
		queryClient.invalidateQueries({ queryKey, exact: true })
	}, [queryKey, queryClient, allDrivesQueryRef])

	const { data, isFetching } = useQuery({
		queryKey: queryKey,
		queryFn: () =>
			driverMapApi.getDrivesByUserId({
				user_id: userId,
				end_after: fromDate,
				start_before: toDate,
				driveId,
				showHistory,
				userOffset: environment?.userCurrent?.time?.timezone?.offset || 0,
				token: environment?.apiToken,
			}),
		enabled: !!queryKey && !!environment?.apiToken, // Only fetch if enabled
	})

	return {
		allDrives: driveId
			? data?.data?.data.filter((drive) => drive.id === driveId)
			: data?.data?.data || [],
		isLoadingDrives: !userId ? false : isFetching,
	}
}
